export const aiAnalytics = {
  title: "AI Analytics",
  description: "Analyze your data with AI assistance",
  metrics: {
    visitors: "Visitors",
    sales: "Sales",
    revenue: "Revenue",
    conversionRate: "Conversion Rate"
  },
  timeframe: {
    label: "Timeframe",
    last7days: "Last 7 days",
    last30days: "Last 30 days",
    last90days: "Last 90 days",
    thisYear: "This year"
  },
  chat: {
    title: "AI Analytics Assistant",
    placeholder: "Ask about your data...",
    examples: {
      title: "Example questions:",
      question1: "Which product performs best?",
      question2: "What trends do you see in sales?",
      question3: "When do I get the most visitors?",
      question4: "How can I improve conversion?"
    }
  },
  charts: {
    visitorsOverTime: "Visitors Over Time",
    salesByProduct: "Sales by Product",
    revenueOverTime: "Revenue Over Time",
    trafficSources: "Traffic Sources"
  },
  button: {
    analyze: "Analyze",
    export: "Export",
    refresh: "Refresh"
  }
};
